import { get } from "@/modules/request";
import {
  CursorPageRequest,
  CursorPageResponse,
  PageRequest,
  PageResponse,
  Response,
  WriteResponse,
} from "@/types/api-types";
import { CoinRank, CoinRankItem, OveralCoinRankItem } from "@/types/coinRank";
import { CoinBalanceRecordEntityType, CoinVote } from "@/types/coin";

/** 获取（历史）榜单列表 */
export async function readCoinRankPage(
  params: PageRequest<void>
): Promise<PageResponse<CoinRank>> {
  return get("/CoinRank/ReadPage", params);
}

/** 获取单项榜单列表[时间 - 维度（游戏/故事/角色）]
 * @param id 榜单id，传0查询当期榜单
 * @param params entityType 榜单维度
 */
export async function findOneCoinRank(
  id: number,
  params?: { entityType: CoinBalanceRecordEntityType }
): Promise<WriteResponse<CoinRank>> {
  return get(`/CoinRank/FindOne/${id}`, params);
}

/** 获取榜单项列表 */
export type CoinRanItemPageFilterType = {
  galGameId?: number;
  mateId?: number;
  storyBookId?: number;
  collectionId?: number;
  coinRankId: number;
};

export async function readCoinRankItemPage(
  params: PageRequest<CoinRanItemPageFilterType>
): Promise<PageResponse<CoinRankItem>> {
  return get("/CoinRankItem/ReadPage", params);
}

/** 查询投票记录
 * @param request.coinRankId 排行榜id
 */
export async function readCoinVotePage(
  request: CursorPageRequest<{
    coinRankId: number;
    entityType?: CoinBalanceRecordEntityType;
    entityId?: number;
    isGolden?: 0 | 1;
  }>
): Promise<CursorPageResponse<CoinVote>> {
  return get("/CoinVote/ReadPage", request);
}

export async function readOverallCoinRank(params: {
  entityType: "mate" | "galgame" | "storyBook" | "collection";
  cursor?: string;
  perPage?: number;
}): Promise<
  Response<{
    list: OveralCoinRankItem[];
    nextCursor?: string;
  }>
> {
  return get("/CoinRank/ReadOverall", params);
}
